import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { QueryHighlightModel } from '../../models/query-highlight-model';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import type { QueryHighlight } from '../../types';
import type { QueryHighlightService } from '../query-highlight-service';

@injectable()
export class QueryHighlightServiceImpl implements QueryHighlightService {
    private _onStatesChangeEmitter = new Emitter<QueryHighlight>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(QueryHighlightModel)
        private _model: QueryHighlightModel,
    ) {
        this._model.onStatesChange(this._emitModelDataChange.bind(this));
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getModelData());
    }

    public getModelData() {
        return this._model.modelData;
    }

    public updateQueryHighlight(queryHighlight: QueryHighlight) {
        this._model.update(() => queryHighlight);
    }
}
